import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { COMPLETION_DATE, STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';
import { COMPLETED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import DateTimeCell from './DateTimeCell';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskCompletionDateCell = ({
  original: cdtTask
}) => {
  const completionDate = getProperty(cdtTask, COMPLETION_DATE);
  const status = getProperty(cdtTask, STATUS);
  const value = status === COMPLETED ? completionDate : null;
  return /*#__PURE__*/_jsx(DateTimeCell, {
    format: "LLL",
    i18nTimezoneType: TimezoneTypes.USER,
    value: value
  });
};
export default TaskCompletionDateCell;